import { Button, LinearProgress, Stack, Typography } from "@mui/material";
import { FC, Fragment, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { GridApi } from "ag-grid-community";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsRecommendationsLoadingSelector } from "@/store/commitments/selectors/recommendations/data/commitmentsRecommendationsLoadingSelector";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";
import {
  setCommitmentsDataViewTab,
  setCommitmentsTypeTab,
} from "@/store/commitments/commitmentsSlice";

interface SavingPlansRecommendationsOverviewAGGridToolbarProps {
  gridApi: GridApi | null;
}

export const SavingPlansRecommendationsOverviewAGGridToolbar: FC<
  SavingPlansRecommendationsOverviewAGGridToolbarProps
> = ({ gridApi }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector(commitmentsRecommendationsLoadingSelector);

  const handleCommitmentTabChange = useCallback(() => {
    dispatch(setCommitmentsTypeTab("recommendation"));
    dispatch(setCommitmentsDataViewTab("saving_plans"));
    navigate({ search: `active=recommendation` });
  }, [dispatch, navigate]);

  return (
    <Fragment>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        gap={1}
        flexWrap="wrap"
        p={1}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            variant="subtitle1"
            fontWeight="medium"
            color="text.secondary"
            px={1}
          >
            Savings Plans Recommendations
          </Typography>

          <span>
            <AgGridAllFiltersChip gridApi={gridApi} />
          </span>
        </Stack>

        <Button variant="outlined" onClick={handleCommitmentTabChange}>
          View In Savings Plans
        </Button>
      </Stack>

      {loading && <LinearProgress />}
    </Fragment>
  );
};
